(function () {
  var root = document.getElementById('notb-batch');
  if (!root) return;
  var L = root.getAttribute('data-lang') === 'en' ? 'en' : 'nl';
  var T = {
    nl: { wait: 'Wacht...', busy: 'Analyseren...', bad: 'Kan niet openen', none: '?', prog: '{a} van {b} klaar', free: 'Gratis analyseer je 3 bestanden tegelijk.', hint: 'Tik op een track om te zien wat ermee mixt.', match: '{n} mixbare matches', badcode: 'Deze code klopt niet.', unlocked: 'Pro staat aan. Veel plezier!', zip: 'ZIP maken...', maj: 'majeur', min: 'mineur', file: 'Bestand', key: 'Toonsoort', dur: 'Duur' },
    en: { wait: 'Waiting...', busy: 'Analyzing...', bad: "Can't open", none: '?', prog: '{a} of {b} done', free: 'Free: analyze 3 files at once.', hint: 'Tap a track to see what mixes with it.', match: '{n} mixable matches', badcode: "That code doesn't work.", unlocked: 'Pro is on. Have fun!', zip: 'Creating ZIP...', maj: 'major', min: 'minor', file: 'File', key: 'Key', dur: 'Length' }
  }[L];
  var PRO_HASH = ['a432078cdb5ba379489cafd9c9bf71aafedafca3af54f4c01a2c2294707a2fc1', 'f246009fe15b41057f55cbdbd4f2b8f6c8fcc1f4eba8184b93e0897fc7fc8eab'];
  var SALT = 'notb-bl|', KEY = 'notb_bl_pro', FREE = 3, MAX = 300;
  var WORKER = 'https://nameonthebeat.com/cdn/shop/files/notb-beat-lab-stable-v3-worker.js?v=1791018771';
  var hide = document.createElement('style'); hide.textContent = 'shopify-chat{display:none!important}'; document.head.appendChild(hide);

  var $ = function (s) { return root.querySelector(s); }, $$ = function (s) { return root.querySelectorAll(s); };
  var drop = $('[data-bt-drop]'), tbody = $('[data-bt-rows]'), table = $('[data-bt-table]'), status = $('[data-bt-status]'), hint = $('[data-bt-hint]');
  var proBox = $('[data-bt-probox]'), proMsg = $('[data-bt-promsg]'), codeIn = $('[data-bt-code]'), skipBtn = $('[data-bt-skip]');
  var rows = [], queue = [], running = false, sel = -1, sortKey = null, sortDir = 1, pro = false, worker = null;

  // ------------------------------------------------------------ pro
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function sha(s) {
    if (!window.crypto || !crypto.subtle) return Promise.resolve('');
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(s)).then(function (b) { return Array.prototype.map.call(new Uint8Array(b), function (x) { return ('0' + x.toString(16)).slice(-2); }).join(''); });
  }
  function tryCode(code, silent) {
    var norm = (code || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); if (!norm) return Promise.resolve(false);
    return sha(SALT + norm).then(function (h) {
      if (PRO_HASH.indexOf(h) > -1) { pro = true; store(KEY, h); proUi(); if (!silent) { proMsg.textContent = T.unlocked; setTimeout(closePro, 1200); } return true; }
      if (!silent) proMsg.textContent = T.badcode; return false;
    });
  }
  function proUi() { root.classList.toggle('is-pro', pro); $$('[data-bt-badge]').forEach(function (b) { b.hidden = !pro; }); $('[data-bt-free]').hidden = pro; }
  var saved = store(KEY); if (saved && PRO_HASH.indexOf(saved) > -1) pro = true;
  (function () {
    var m = location.search.match(/[?&]pro=([^&#]+)/);
    if (m) { tryCode(decodeURIComponent(m[1]), false).then(function (ok) { if (ok) openPro(true); }); try { history.replaceState(null, '', location.pathname + location.hash); } catch (e) {} }
  })();
  var after = null;
  function openPro(okOnly, then, skip) {
    after = then || null; proBox.hidden = false; proMsg.textContent = okOnly ? T.unlocked : '';
    skipBtn.hidden = !skip; skipBtn.onclick = skip ? function () { closePro(); skip(); } : null;
    proBox.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); if (okOnly) setTimeout(closePro, 1600);
  }
  function closePro() { proBox.hidden = true; }
  function needPro(fn, skip) { if (pro) return fn(); openPro(false, fn, skip); }
  $('[data-bt-proclose]').addEventListener('click', closePro);
  $('[data-bt-unlock]').addEventListener('click', function () { tryCode(codeIn.value).then(function (ok) { if (ok && after) { var f = after; after = null; f(); } }); });
  codeIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); $('[data-bt-unlock]').click(); } });

  // ------------------------------------------------------------ keys
  var NM = ['C', 'Db', 'D', 'Eb', 'E', 'F', 'F#', 'G', 'Ab', 'A', 'Bb', 'B'], NMm = ['C', 'C#', 'D', 'Eb', 'E', 'F', 'F#', 'G', 'G#', 'A', 'Bb', 'B'];
  var CAM_MIN = [5, 12, 7, 2, 9, 4, 11, 6, 1, 8, 3, 10], CAM_MAJ = [8, 3, 10, 5, 12, 7, 2, 9, 4, 11, 6, 1];
  function keyInfo(k) {
    if (!k) return null;
    var minor = k.mode === 'minor', n = (minor ? NMm : NM)[k.root];
    return { long: n + ' ' + (minor ? T.min : T.maj), short: n + (minor ? 'm' : ''), cam: (minor ? CAM_MIN : CAM_MAJ)[k.root] + (minor ? 'A' : 'B'), num: (minor ? CAM_MIN : CAM_MAJ)[k.root], ab: minor ? 'A' : 'B' };
  }
  function camMatch(a, b) {
    if (!a || !b) return false;
    if (a.num === b.num) return true;
    if (a.ab !== b.ab) return false;
    var d = Math.abs(a.num - b.num); return d === 1 || d === 11;
  }
  function bpmMatch(a, b) {
    if (!a || !b) return true;
    return [0.5, 1, 2].some(function (r) { return Math.abs(a - b * r) <= b * r * 0.06; });
  }

  // ------------------------------------------------------------ analysis
  function segments(len, sr) { // same windows as Beat Lab
    var t = len / sr, starts = t <= 30 ? [0] : [0.08, 0.45, 0.82].map(function (l) { return Math.floor((t - 20) * l * sr); }), r = Math.floor(Math.min(30, t <= 30 ? t : 20) * sr);
    return starts.map(function (s) { return [s, Math.min(len, s + r)]; });
  }
  function decode(file) {
    return file.arrayBuffer().then(function (ab) {
      var oc = new OfflineAudioContext(1, 1, 11025);
      return new Promise(function (res, rej) { oc.decodeAudioData(ab, res, rej); });
    });
  }
  function getWorker() { if (!worker) worker = new Worker(WORKER, { type: 'module' }); return worker; }
  function analyze(buf) {
    var best = 0, bi = 0;
    for (var c = 0; c < buf.numberOfChannels; c++) { var d = buf.getChannelData(c), e = 0; for (var i = 0; i < d.length; i += 97) e += d[i] * d[i]; if (e > best) { best = e; bi = c; } }
    var data = buf.getChannelData(bi), segs = segments(data.length, 11025).map(function (r) { return data.slice(r[0], r[1]); });
    return new Promise(function (res, rej) {
      var w = getWorker(), to = setTimeout(function () { w.terminate(); worker = null; rej(new Error('timeout')); }, 45000);
      w.onmessage = function (ev) {
        var m = ev.data; if (m.type === 'progress') return;
        clearTimeout(to); if (m.type === 'result') res(m.result); else rej(new Error('fail'));
      };
      w.onerror = function () { clearTimeout(to); worker = null; rej(new Error('err')); };
      w.postMessage({ segments: segs, sampleRate: 11025 }, segs.map(function (s) { return s.buffer; }));
    });
  }
  function pump() {
    if (running) return;
    var r = queue.shift(); if (!r) { progress(); return; }
    running = true; r.state = 'busy'; render();
    decode(r.file).then(function (buf) {
      r.dur = buf.duration;
      return analyze(buf).then(function (res) {
        r.bpm = res.bpm || (res.tempoCandidates && res.tempoCandidates[0] ? res.tempoCandidates[0].bpm : null);
        r.bpmSure = !!res.bpm;
        var k = res.key || (res.candidates && res.candidates[0] ? { root: res.candidates[0].root, mode: res.candidates[0].mode } : null);
        r.key = keyInfo(k); r.keySure = !!res.key && !res.ambiguous;
        r.state = 'done';
      });
    }).catch(function () { r.state = 'err'; }).then(function () { running = false; render(); progress(); pump(); });
  }
  function progress() {
    var done = rows.filter(function (r) { return r.state === 'done' || r.state === 'err'; }).length;
    status.textContent = rows.length ? T.prog.replace('{a}', done).replace('{b}', rows.length) : '';
    var ready = done === rows.length && rows.length > 0;
    $$('[data-bt-act]').forEach(function (b) { b.disabled = !ready; });
  }

  // ------------------------------------------------------------ table
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fmtDur(s) { if (!s) return ''; return Math.floor(s / 60) + ':' + ('0' + Math.floor(s % 60)).slice(-2); }
  function fmtBpm(r) { if (r.state !== 'done') return ''; if (!r.bpm) return T.none; var v = Math.round(r.bpm * 10) / 10; return (v % 1 ? v.toFixed(1) : v) + (r.bpmSure ? '' : '?'); }
  function render() {
    table.hidden = !rows.length; drop.classList.toggle('is-loaded', rows.length > 0);
    var order = rows.map(function (r, i) { return i; });
    if (sortKey) order.sort(function (a, b) {
      var A = rows[a], B = rows[b], x, y;
      if (sortKey === 'bpm') { x = A.bpm || 1e9; y = B.bpm || 1e9; }
      else if (sortKey === 'cam') { x = A.key ? A.key.num * 2 + (A.key.ab === 'B') : 99; y = B.key ? B.key.num * 2 + (B.key.ab === 'B') : 99; }
      else if (sortKey === 'dur') { x = A.dur || 0; y = B.dur || 0; }
      else { x = A.file.name.toLowerCase(); y = B.file.name.toLowerCase(); }
      return (x > y ? 1 : x < y ? -1 : 0) * sortDir;
    });
    var s = sel > -1 ? rows[sel] : null, mcount = 0;
    tbody.innerHTML = order.map(function (i) {
      var r = rows[i], cls = [];
      if (i === sel) cls.push('is-sel');
      else if (s && s.state === 'done' && r.state === 'done' && camMatch(s.key, r.key) && bpmMatch(s.bpm, r.bpm)) { cls.push('is-match'); mcount++; }
      if (r.state === 'err') cls.push('is-err');
      var keyTxt = r.state === 'busy' ? T.busy : r.state === 'queued' ? T.wait : r.state === 'err' ? T.bad : r.key ? r.key.long + (r.keySure ? '' : '?') : T.none;
      return '<tr data-i="' + i + '" class="' + cls.join(' ') + '"><td class="bt-f">' + esc(r.file.name) + '</td><td class="bt-b">' + fmtBpm(r) + '</td><td class="bt-k">' + esc(keyTxt) + '</td><td class="bt-c">' + (r.state === 'done' && r.key ? '<span class="bt-cam">' + r.key.cam + '</span>' : '') + '</td><td class="bt-d">' + fmtDur(r.dur) + '</td></tr>';
    }).join('');
    hint.textContent = s ? T.match.replace('{n}', mcount) : rows.length > 1 ? T.hint : '';
    $$('[data-bt-sort]').forEach(function (h) { h.setAttribute('aria-sort', h.getAttribute('data-bt-sort') === sortKey ? (sortDir > 0 ? 'ascending' : 'descending') : 'none'); });
  }
  tbody.addEventListener('click', function (e) {
    var tr = e.target.closest('tr'); if (!tr) return;
    var i = +tr.getAttribute('data-i'); sel = sel === i ? -1 : i; render();
  });
  $$('[data-bt-sort]').forEach(function (h) {
    h.addEventListener('click', function () { var k = h.getAttribute('data-bt-sort'); if (sortKey === k) sortDir = -sortDir; else { sortKey = k; sortDir = 1; } render(); });
  });

  function isAudio(f) { return /^audio\//.test(f.type) || /\.(wav|mp3|m4a|aac|flac|ogg|oga|opus|aif|aiff)$/i.test(f.name); }
  function addFiles(list) {
    var fl = Array.prototype.filter.call(list, isAudio);
    if (!fl.length) return;
    function go(arr) {
      arr.forEach(function (f) { var r = { file: f, state: 'queued' }; rows.push(r); queue.push(r); });
      render(); progress(); pump();
    }
    var room = (pro ? MAX : FREE) - rows.length;
    if (fl.length <= room) return go(fl);
    if (pro) return go(fl.slice(0, Math.max(0, room)));
    openPro(false, function () { go(fl.slice(0, MAX - rows.length)); }, function () { go(fl.slice(0, Math.max(0, room))); });
  }
  $$('[data-bt-file]').forEach(function (inp) { inp.addEventListener('change', function () { addFiles(inp.files); inp.value = ''; }); });
  ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-drag'); }); });
  ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-drag'); }); });
  drop.addEventListener('drop', function (e) { if (e.dataTransfer.files.length) addFiles(e.dataTransfer.files); });

  // ------------------------------------------------------------ export (Pro)
  function save(name, data, type) {
    var url = URL.createObjectURL(new Blob([data], { type: type })), a = document.createElement('a');
    a.href = url; a.download = name; a.className = 'bt-hidden'; root.appendChild(a); a.click();
    setTimeout(function () { a.remove(); URL.revokeObjectURL(url); }, 60000);
  }
  function csv() {
    var sep = L === 'nl' ? ';' : ',', q = function (v) { v = v == null ? '' : String(v); return /[";,\n]/.test(v) ? '"' + v.replace(/"/g, '""') + '"' : v; };
    var lines = [[T.file, 'BPM', T.key, 'Camelot', T.dur].join(sep)];
    rows.forEach(function (r) { lines.push([r.file.name, r.bpm ? (L === 'nl' ? String(Math.round(r.bpm * 10) / 10).replace('.', ',') : Math.round(r.bpm * 10) / 10) : '', r.key ? r.key.long : '', r.key ? r.key.cam : '', fmtDur(r.dur)].map(q).join(sep)); });
    save('NameOnTheBeat BPM key.csv', '﻿' + lines.join('\r\n'), 'text/csv');
  }
  function renamed() {
    status.textContent = T.zip;
    var out = [], seen = {};
    Promise.all(rows.filter(function (r) { return r.state === 'done'; }).map(function (r) {
      return r.file.arrayBuffer().then(function (ab) {
        var m = r.file.name.match(/^(.*?)(\.[^.]+)?$/), base = m[1].replace(/\s*-\s*\d+(\.\d+)?\s*BPM.*$/i, ''), ext = m[2] || '';
        var parts = [base]; if (r.bpm) parts.push(Math.round(r.bpm) + ' BPM'); if (r.key) parts.push(r.key.cam + ' ' + r.key.short);
        var n = parts.join(' - ') + ext, k = 2; while (seen[n]) n = parts.join(' - ') + ' (' + (k++) + ')' + ext; seen[n] = 1;
        out.push({ name: n, data: new Uint8Array(ab) });
      });
    })).then(function () { save('NameOnTheBeat met BPM en key.zip', NAUDIO.zip(out), 'application/zip'); progress(); });
  }
  $('[data-bt-csv]').addEventListener('click', function () { needPro(csv); });
  $('[data-bt-zip]').addEventListener('click', function () { needPro(renamed); });
  $('[data-bt-clear]').addEventListener('click', function () { rows = []; queue = []; sel = -1; render(); progress(); });

  proUi(); render(); progress();
})();
